// extracted by mini-css-extract-plugin
export default {"externalIndicatorContainer":"OperationExternalTip_externalIndicatorContainer__VY15q","externalLabel":"OperationExternalTip_externalLabel__Enseb"};